/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable import/no-extraneous-dependencies */
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
// eslint-disable-next-line import/no-extraneous-dependencies
import { withRouter } from 'react-router-dom';
import Heading from '../../../components/Web/ContactInfo/redesign/FuncComp/heading';
import * as Actions from '../actions';

const mapStateToProps = () =>
  // const cqContent = state.get('cqContent').toJS();
  ({});
const mapDispatchToProps = (dispatch) => bindActionCreators({ ...Actions }, dispatch);

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default withRouter(compose(withConnect)(Heading));
